import { gql } from '@apollo/client';

export const indexEventAttributeMutation = gql`
    mutation indexEventAttributeMutation($name:String, $description:String, $eventDataAttribute:ID!){
        result:indexEventDataAttribute(name:$name, description: $description, eventDataAttribute: $eventDataAttribute, operation: create){
            id
            name
            type
        }
    }
`;

export const removeIndexEventAttributeMutation = gql`
    mutation indexEventAttributeMutation($name:String, $eventDataAttribute:ID!){
        result:indexEventDataAttribute(name:$name, eventDataAttribute: $eventDataAttribute, operation: delete){
            id
            name
            type
        }
    }
`;